import React, { useEffect, useState } from 'react';
import { Container, Row } from "react-bootstrap";
import { Button, Select, Flex, message, Modal } from 'antd';
import { AudienceFilter } from '../components/audiencia/AudienceFilter';
import { AudienceContent } from '../components/audiencia/AudienceContent';
import WizardComponent from '../components/wizard/WizardComponent';
import  UseApiService  from './../../services/Api.service'
import * as constants from './../../constants/constants'
import {TeamOutlined} from '@ant-design/icons'

export default function AudiencePage(){
  const [loading,setLoading] = useState(false);  
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchValue,setSearchValue] = useState();  
  const [filteredData, setFilteredData] = useState([]);
  const [data,setData] = useState();
  const [rowSelected,setRowSelected]= useState(null);
  const [experiencieSelected,setExperienceSelected]= useState(null);
  //const [columns,setColumnns] = useState();
  const [wizardVisible, setWizardVisible] = useState(false);

  const columns = [    
    {
      title: 'Audiencia',
      dataIndex: 'audiencia',        
      render:(text) =>(
        <span className="fs-6">{text}</span>
      )
    },
    {
      title: '90 días',
      dataIndex: 'ultimos90',        
      width:'120px',
      render:(text) =>(
        <>{text} K</>
      )
    },
    {
      title: '60 días',
      dataIndex: 'ultimos60',
      width:'120px',
      render:(text) =>(
        <>{text} K</>
      )
    },
    {
      title: '30 días',
      dataIndex: 'ultimos30',
      width:'120px',
      render:(text) =>(
        <>{text} K</>
      )
    },
    {
      title: '',
      dataIndex: '',
      width:'220px',
      render: (text, record) => (        
        <>
        <Flex gap="small" wrap>          
          <Button color="primary" variant="outlined" onClick={()=>{showModal(record)}} >
            Aplicar experiencia
          </Button>
        </Flex>
        </>
      )
    },
  ];

  useEffect(()=>{    

    const url = constants.U_API2+'?opt=data';
    setLoading(true);
    UseApiService(url,{method:'GET'})
    .then(({data,error}) =>{      
      if(error){        
        message.warning('Ocurrio un error: '.error);
      }
      else{        
        setData(data);
      }
    })
    .catch((e)=>{
      console.log(e);
      message.warning('Ocurrio un error:'.e);
    })
    .finally((e)=>{
      setLoading(false);
    });
  },[])

  useEffect(()=>{
    setFilteredData(data);
  },[data])

  const handleChange = (value) => {    
    setExperienceSelected(value);
  };

  const onSearch = (value) => {
    setLoading(true);
    setSearchValue(value);
    if (value) {
      const filtered = data.filter(item =>
        item.audiencia.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);     
    }
    setLoading(false);
  };

  const showModal = (row) => {
    setExperienceSelected('Seleccionar');
    setRowSelected(row)
    setIsModalOpen(true);
  };

  const handleOk = () => {
    message.info('Aplicando '+experiencieSelected + ' en ' + rowSelected.audiencia);
    setIsModalOpen(false);    
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCreateNew = () => {    
    setWizardVisible(true)
  }

  return(
    <>
      <Container className="content">
        <Row>
          <span className='h3 mt-1 text-black'><TeamOutlined /> Audiencias</span>
        </Row>
        <Row className='mt-3'>
          <AudienceFilter handelSearch={onSearch} loading={loading} handleCreateNew={handleCreateNew} />
        </Row>
        <Row>
          <AudienceContent data={filteredData} columns={columns} loading={loading} />
        </Row>
      </Container>
      <Modal
        title={'Seleccionar experiencia'}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText='Aplicar'
        centered
        width={350}
      >
        <div className='my-2'>
          <span>Selecciona una opción que deseas aplicar a la audiencia: </span>
          <span className='fw-bolder'>{rowSelected?.audiencia}</span>
        </div>
        <Select
          defaultValue="Seleccionar"
          value={experiencieSelected}
          data={rowSelected?.key}
          style={{ width: "100%" }}          
          onChange={handleChange}
          className='my-2'
          options={[
            { value: 'experiencia1', label: 'Experiencia 1' },
            { value: 'experiencia2', label: 'Experiencia 2' },
            { value: 'experiencia3', label: 'Experiencia 3' },
            { value: 'experiencia4', label: 'Experiencia 4' },
            { value: 'experiencia5', label: 'Experiencia 5' }            
          ]}
        />
      </Modal>
      <WizardComponent
        open={wizardVisible}
        onClose={() => setWizardVisible(false)}
      />
    </>
  )
}